import { render, staticRenderFns } from "./BrandPinChartBar.vue?vue&type=template&id=d2c8a302"
import script from "./BrandPinChartBar.vue?vue&type=script&lang=js"
export * from "./BrandPinChartBar.vue?vue&type=script&lang=js"
import style0 from "./BrandPinChartBar.vue?vue&type=style&index=0&id=d2c8a302&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports